/* eslint-disable react/prop-types */
/* we can re-enable this when (if) AmazonLogin is ever revived (dead feature) */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { AmazonLoginStatus } from '../../../constants/AppConstants';
import t from '../../../lib/I18n';
import BAlert, { bAlertType } from '../../general/BAlert';
import BaseModal from '../../general/BaseModal';
import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';
import ValidatedField from '../../form/ValidatedField';
import AmazonLoginActions from '../../../actions/AmazonLoginActions';

const makeInput = ({
        autoFocus,
        disabled = false,
        field,
        handleFieldChange,
        isProcessing,
        label,
        loginForm,
        submitted,
        type,
        value
    }) => {

    return (
        <ValidatedField
            autoFocus={ autoFocus }
            disabled={ disabled || isProcessing }
            field={ field }
            form={ loginForm }
            id={ field }
            label={ label }
            labelClassName="sr-only"
            onChange={ handleFieldChange }
            placeholder={ label }
            required
            type={ type }
            value={ value }
            visited={ submitted }
        />
    );
};

const AmazonLinkModal = ({
        customer,
        disableContinue,
        handleFieldChange,
        isProcessing,
        loginForm,
        onContinue,
        onClose,
        status,
        submitted
    }) => {
    const passwordInput = makeInput({
        autoFocus: true,
        field: 'password',
        handleFieldChange,
        isProcessing,
        label: t('login.link.password', { accountType: t('app.owner.short') }),
        loginForm,
        submitted,
        type: 'password'
    });

    const closeModal = () => {
        AmazonLoginActions.logout(); // Log out the Amazon user in case they want to use another Amazon acccount
        onClose();
    };

    const modalProps = {
        className: 'modal--xs',
        closeText: t('login.link.amazon.closeText'),
        continueText: t('login.link.amazon.continueText'),
        disableContinue,
        onClose: closeModal,
        onContinue,
        titleText: t('login.link.amazon.title')
    };

    return (<BaseModal { ...modalProps }>
        <section>
            <div className="text-center">
                <p>
                    <FormattedHTMLMessage
                        message="login.link.amazon.message"
                        accountType={ t('app.owner.short') }
                        email={ customer.email } />
                </p>

                <div className="header__logo">
                    <span className="sr-only">{t('app.owner')}</span>
                </div>
                <p>
                    <FormattedHTMLMessage message="login.link.amazon.loginAccount" accountType={ t('app.owner.short') } />
                </p>

                {status === AmazonLoginStatus.LINK_ERROR && <BAlert type={ bAlertType.DANGER } className="margin-bottom--sm">
                        { t('login.link.amazon.error', { accountType: t('app.owner.short') }) }
                    </BAlert>}

                <p>
                    {passwordInput}
                </p>
            </div>
        </section>
    </BaseModal>);
};

AmazonLinkModal.propTypes = {
    onClose: PropTypes.func,
    onRegister: PropTypes.func
};

AmazonLinkModal.defaultProps = {
    onClose: _.noop,
    onRegister: _.noop
};

export default AmazonLinkModal;



// WEBPACK FOOTER //
// ./src/components/login/amazon/AmazonLinkModal.js